import { API_URL } from "../Constants/constants";

/**
 * Planos e preços reais do Stripe (público, cacheado no backend).
 * Resolve com `[]` se o backend ainda não tiver Prices configurados.
 */
export const fetchPlanos = async ({ signal } = {}) => {
  const response = await fetch(`${API_URL}/billing/planos`, {
    headers: { Accept: "application/json" },
    signal,
  });

  if (!response.ok) {
    throw new Error(`GET /billing/planos respondeu ${response.status}`);
  }

  const data = await response.json();
  return Array.isArray(data?.planos) ? data.planos : [];
};
